<form #form="ngForm">
    <ng-container *ngIf="benefitPlan">
        <div *ngIf="isLoading" class="ui active inverted dimmer">
            <div class="ui loader"></div>
        </div>
        <div class="app-grid">
            <mat-form-field class="columns-6 small-columns-12">
                <mat-label>{{ 'benefits.benefitPlanCreationForm.name' | translate }}</mat-label>
                <input
                    type="text"
                    matInput
                    name="name"
                    required
                    #name="ngModel"
                    [(ngModel)]="benefitPlan.name"
                    placeholder="{{ 'benefits.benefitPlanCreationForm.namePlaceholder' | translate }}"
                />

                <mat-error *ngIf="name.invalid">{{ name.errors | formErrors }}</mat-error>
            </mat-form-field>

            <mat-form-field class="columns-6 small-columns-12">
                <mat-label appRemoveAriaOwns>{{ 'benefits.benefitPlanCreationForm.provider' | translate }}</mat-label>
                <mat-select
                    required
                    #providerId="ngModel"
                    placeholder="{{ 'benefits.benefitPlanCreationForm.providerPlaceholder' | translate }}"
                    name="providerId"
                    [(ngModel)]="benefitPlan.providerId"
                >
                    <mat-option *ngFor="let provider of benefitProviders" [value]="provider.id">{{
                        provider.name
                    }}</mat-option>
                </mat-select>
                <mat-error *ngIf="providerId.invalid">{{ providerId.errors | formErrors }}</mat-error>
            </mat-form-field>
        </div>

        <div class="app-grid">
            <mat-form-field class="columns-6 small-columns-12">
                <mat-label>{{ 'benefits.benefitPlanCreationForm.policyNumber' | translate }}</mat-label>
                <input
                    type="text"
                    matInput
                    #policyNumber="ngModel"
                    placeholder="{{ 'benefits.benefitPlanCreationForm.policyNumberPlaceholder' | translate }}"
                    name="policyNumber"
                    [(ngModel)]="benefitPlan.policyNumber"
                />
                <mat-error *ngIf="policyNumber.invalid">{{ policyNumber.errors | formErrors }}</mat-error>
            </mat-form-field>

            <mat-form-field class="columns-6 small-columns-12">
                <mat-label>{{ 'benefits.classIdentifier' | appTranslate }}</mat-label>
                <input
                    type="text"
                    matInput
                    #classIdentifier="ngModel"
                    placeholder="{{ 'benefits.classIdentifierInputPlaceholder' | appTranslate }}"
                    name="classIdentifier"
                    [(ngModel)]="benefitPlan.classIdentifier"
                />
                <mat-error *ngIf="classIdentifier.invalid">{{ classIdentifier.errors | formErrors }}</mat-error>
            </mat-form-field>
        </div>

        <div class="app-grid">
            <mat-form-field class="columns-3 small-columns-12">
                <mat-label>{{ 'benefits.benefitPlanCreationForm.probationPeriod' | translate }}</mat-label>
                <input
                    type="number"
                    min="0"
                    required
                    matInput
                    #probationPeriodValue="ngModel"
                    placeholder="{{ 'benefits.benefitPlanCreationForm.probationPeriodPlaceholder' | translate }}"
                    name="probationPeriodValue"
                    [(ngModel)]="benefitPlan.probationPeriodValue"
                />
                <mat-error *ngIf="probationPeriodValue.invalid">{{
                    probationPeriodValue.errors | formErrors
                }}</mat-error>
            </mat-form-field>
            <mat-form-field class="columns-3 small-columns-12">
                <mat-select name="probationPeriodType" [(ngModel)]="benefitPlan.probationPeriodType">
                    <mat-option value="day">{{ 'benefits.benefitPlanCreationForm.days' | translate }}</mat-option>
                    <mat-option value="week">{{ 'benefits.benefitPlanCreationForm.weeks' | translate }}</mat-option>
                    <mat-option value="month">{{ 'benefits.benefitPlanCreationForm.months' | translate }}</mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field class="columns-6 small-columns-12">
                <mat-label>{{ 'benefits.benefitPlanCreationForm.effectiveDate' | translate }}</mat-label>
                <input
                    name="startAt"
                    #startAt="ngModel"
                    required
                    [(ngModel)]="benefitPlan.startAt"
                    [matDatepicker]="effectiveAtDatePicker"
                    matInput
                />
                <mat-datepicker-toggle matSuffix [for]="effectiveAtDatePicker">
                    <mat-icon matDatepickerToggleIcon svgIcon="calendar"></mat-icon>
                </mat-datepicker-toggle>
                <mat-datepicker #effectiveAtDatePicker></mat-datepicker>
                <mat-error *ngIf="startAt.invalid">{{ startAt.errors | formErrors }}</mat-error>
            </mat-form-field>
        </div>

        <div class="app-grid">
            <mat-form-field class="columns-6 small-columns-12">
                <mat-label>{{ 'benefits.benefitPlanCreationForm.renewalDate' | translate }}</mat-label>
                <input
                    name="expireAt"
                    #expireAt="ngModel"
                    required
                    [(ngModel)]="benefitPlan.expireAt"
                    [matDatepicker]="expireAtDatePicker"
                    matInput
                />
                <mat-datepicker-toggle matSuffix [for]="expireAtDatePicker">
                    <mat-icon matDatepickerToggleIcon svgIcon="calendar"></mat-icon>
                </mat-datepicker-toggle>
                <mat-datepicker #expireAtDatePicker></mat-datepicker>
                <mat-error *ngIf="expireAt.invalid">{{ expireAt.errors | formErrors }}</mat-error>
            </mat-form-field>

            <mat-form-field class="columns-6 small-columns-12">
                <mat-label>{{ 'benefits.benefitPlanCreationForm.planUrl' | translate }}</mat-label>
                <input
                    type="text"
                    matInput
                    #planUrl="ngModel"
                    placeholder="{{ 'benefits.benefitPlanCreationForm.planUrlPlaceholder' | translate }}"
                    name="planUrl"
                    [(ngModel)]="benefitPlan.planUrl"
                />

                <mat-error *ngIf="planUrl.invalid">{{ planUrl.errors | formErrors }}</mat-error>
            </mat-form-field>
        </div>

        <div class="app-grid">
            <mat-form-field class="columns-6 small-columns-12">
                <mat-label>{{ 'benefits.benefitPlanCreationForm.benefitBooklet' | translate }}</mat-label>
                <ui-mat-file-upload
                    #file="ngModel"
                    [ngModel]="benefitPlan.file"
                    (fileSelected)="saveBooklet($event)"
                    placeholder="{{ 'benefits.benefitPlanCreationForm.benefitBookletPlaceholder' | translate }}"
                    [allowedTypes]="['.pdf']"
                    name="booklet"
                ></ui-mat-file-upload>
                <ui-button type="outline">{{ 'benefits.benefitPlanCreationForm.browse' | translate }}</ui-button>
                <mat-error *ngIf="file.invalid">{{ file.errors | formErrors }}</mat-error>
            </mat-form-field>
        </div>
    </ng-container>
</form>
